export default __webpack_public_path__ + "static/media/proj3_9.e84b9072.jpg";